export default "__VITE_ASSET__464cf5cc__"